// Counter
export const INCREMENT_COUNTER = 'INCREMENT_COUNTER'
export const DECREMENT_COUNTER = 'DECREMENT_COUNTER'



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js